import { Injectable } from '@angular/core'
import { Document } from '@awork/features/document/models/document.model'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'

@Injectable({ providedIn: 'root' })
export class DocumentStore extends EntitySignalStore<Document> {
  constructor() {
    super({
      name: 'document',
      entityConstructor: document => new Document(document),
      persistActiveState: false,
      excludePersistProps: ['content'],
      nullableProps: [
        'currentDocumentVersionId',
        'documentSpaceId',
        'parentId',
        'projectId',
        'taskId',
        'meetingCaptureId',
        'order',
        'movedToTrashOn',
        'movedToTrashBy'
      ]
    })
  }

  /**
   * Preserves the content of the document when updating
   * @param {Document} prevEntity
   * @param {Partial<Document>} nextEntity
   * @returns {Partial<Document>}
   */
  preUpdateEntity(prevEntity: Document, nextEntity: Partial<Document>): Partial<Document> {
    const content = nextEntity.content !== undefined ? nextEntity.content : prevEntity.content

    return { ...nextEntity, content }
  }
}
